export enum IconFormNames {
  ArchiveDocumentsBoxBig = 'archive-documents-box-big',
  Inbox = 'inbox',
  CalendarUpcoming = 'calendar-upcoming',
  DotsMenu = 'dots-menu',
  ClockWatch = 'clock-watch',
  ThreeDGlasses = 'user-select-3d-glasses',
  AiChip = 'user-select-ai-chip',
  Apple = 'user-select-apple',
  AsianFood = 'user-select-asian-food',
  Baby = 'user-select-baby',
  Backpack = 'user-select-backpack',
  BandageShoulder = 'user-select-bandage-shoulder',
  BatteryChargingLightning = 'user-select-battery-charging-lightning',
  Bed = 'user-select-bed',
  Bicycle = 'user-select-bicycle',
  Bitcoin = 'user-select-bitcoin',
  Boat = 'user-select-boat',
  BookOpen = 'user-select-book-open',
  Bus = 'user-select-bus',
  Cake = 'user-select-cake',
  Camera = 'user-select-camera',
  Campfire = 'user-select-camp-fire',
  Car = 'user-select-car',
  Cat = 'user-select-cat',
  ChampagneGlasses = 'user-select-champagne-glasses',
  Chart = 'user-select-chart',
  ChefHat = 'user-select-chef-hat',
  ColorPalette = 'user-select-color-palette',
  Computer = 'user-select-computer',
  Croissant = 'user-select-croissant',
  Coins = 'user-select-coins',
  CoinsDocumentChart = 'user-select-coins-document-chart',
  Dog = 'user-select-dog',
  Dollar = 'user-select-dollar',
  EducationAndLearning = 'user-select-education-and-learning',
  Eggplant = 'user-select-eggplant',
  Euro = 'user-select-euro',
  ExamAGradeSquare = 'user-select-exam-a-grade-square',
  FamilyAndFriends = 'user-select-family-and-friends',
  Fireworks = 'user-select-fireworks',
  Fish = 'user-select-fish',
  ForkKnife = 'user-select-fork-knife',
  FunAndRelaxation = 'user-select-fun-and-relaxation',
  GameCardsDiamond = 'user-select-game-cards-diamond',
  GameController = 'user-select-game-controller',
  Gbp = 'user-select-gbp',
  GiftBox = 'user-select-gift-box',
  GlassWater = 'user-select-glass-water',
  GlassWater2 = 'user-select-glass-water-2',
  Glasses = 'user-select-glasses',
  Globe = 'user-select-globe',
  GraduateHat = 'user-select-graduate-hat',
  GroupPeople = 'user-select-group-people',
  Hammer = 'user-select-hammer',
  HatMagician = 'user-select-hat-magician',
  Headphones = 'user-select-headphones',
  HealthReport = 'user-select-health-report',
  Heartbeat = 'user-select-heartbeat',
  HomeHouse = 'user-select-home-house',
  HomeHouseKey = 'user-select-home-house-key',
  LabTube = 'user-select-lab-tube',
  LanguageTranslateMessage = 'user-select-language-translate-message',
  LaptopCode = 'user-select-laptop-code',
  LargeBuilding = 'user-select-large-building',
  Leaf = 'user-select-leaf',
  Lock = 'user-select-lock',
  LoveAndRelationships = 'user-select-love-and-relationships',
  LoveChat = 'user-select-love-chat',
  Map = 'user-select-map',
  Meat = 'user-select-meat',
  Medicine = 'user-select-medicine',
  Microphone = 'user-select-microphone',
  MoneyAndFinance = 'user-select-money-and-finance',
  MountainsCloud = 'user-select-mountains-cloud',
  Movies = 'user-select-movies',
  MusicNote = 'user-select-music-note',
  Package = 'user-select-package',
  Pen = 'user-select-pen',
  Pendant = 'user-select-pendant',
  Percentage = 'user-select-percentage',
  PersonalDevelopment = 'user-select-personal-development',
  Phone = 'user-select-phone',
  PiggyBank = 'user-select-piggy-bank',
  PlaceholderIcon = 'user-select-placeholder-icon',
  Plane = 'user-select-plane',
  Repeat = 'user-select-repeat',
  RewardCup = 'user-select-reward-cup',
  Rocket = 'user-select-rocket',
  ServingDome = 'user-select-serving-dome',
  ShoppingBag = 'user-select-shopping-bag',
  ShoppingCart = 'user-select-shopping-cart',
  SmartList = 'user-select-smart-list',
  Snow = 'user-select-snow',
  Spirituality = 'user-select-spirituality',
  SportAmericanFootballHelmet = 'user-select-sport-american-football-helmet',
  SportAndHealth = 'user-select-sport-and-health',
  SportBaseball = 'user-select-sport-baseball',
  SportBasketball = 'user-select-sport-basketball',
  SportBoxingGlove = 'user-select-sport-boxing-glove',
  SportDivingMask = 'user-select-sport-diving-mask',
  SportDumbbell = 'user-select-sport-dumbbell',
  SportFieldSoccerField = 'user-select-sport-field-soccer-field',
  SportFitnessBiceps = 'user-select-sport-fitness-biceps',
  SportFootball = 'user-select-sport-football',
  SportGolf = 'user-select-sport-golf',
  SportHockey = 'user-select-sport-hockey',
  SportHockeyStickPuck = 'user-select-sport-hockey-stick-puck',
  SportJumpingRope = 'user-select-sport-jumping-rope',
  SportMartialArtsSwordFencing = 'user-select-sport-martial-arts-sword-fencing',
  SportRings = 'user-select-sport-rings',
  SportRugbyBall = 'user-select-sport-rugby-ball',
  SportSkatingShoes = 'user-select-sport-skating-shoes',
  SportSlimWaist = 'user-select-sport-slim-waist',
  SportSneakers = 'user-select-sport-sneakers',
  SportSnowboard = 'user-select-sport-snowboard',
  SportSportsHelmet = 'user-select-sport-sports-helmet',
  SportSurfingBoard = 'user-select-sport-surfing-board',
  SportSwimmingPool = 'user-select-sport-swimming-pool',
  SportTennisNet = 'user-select-sport-tennis-net',
  SportTennisRacquet = 'user-select-sport-tennis-racquet',
  SportWaterpoloBall = 'user-select-sport-waterpolo-ball',
  SportYoga = 'user-select-sport-yoga',
  Stars = 'user-select-stars',
  Stethoscope = 'user-select-stethoscope',
  Store = 'user-select-store',
  Sun = 'user-select-sun',
  Sunrise = 'user-select-sunrise',
  Target = 'user-select-target',
  Teeth = 'user-select-teeth',
  Television = 'user-select-television',
  Train = 'user-select-train',
  TravelBag = 'user-select-travel-bag',
  UserHeartHealth = 'user-select-user-heart-health',
  Wallet = 'user-select-wallet',
  WeddingRings = 'user-select-wedding-rings',
  WorkAndCareer = 'user-select-work-and-career',
  Yen = 'user-select-yen',
}
